import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { CTABand } from "@/components/CTABand";
import { AirplaneProgress } from "@/components/AirplaneProgress";
import { Marquee } from "@/components/Marquee";
import { Seo } from "@/components/Seo";
import { SceneJourney } from "@/components/home/SceneJourney";
import { SceneFlight } from "@/components/home/SceneFlight";
import { SceneArrival } from "@/components/home/SceneArrival";
import { Roadmap } from "@/components/home/Roadmap";
import { TrustSection } from "@/components/home/TrustSection";
import { FinalVision } from "@/components/home/FinalVision";

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Effizent Europe",
  description:
    "Portugal Business Consulting & Relocation Partner helping Indians build their future in Portugal — company formation, visas, NIF, banking, relocation and settlement.",
  url: typeof window !== "undefined" ? window.location.origin : "",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Praça Mouzinho de Albuquerque, no 113, 1º andar, Loja 76, Sala A",
    postalCode: "4100-359",
    addressLocality: "Porto",
    addressCountry: "PT",
  },
  telephone: "+351912324121",
  email: "info@effizenteurope.com",
  areaServed: ["Portugal", "India", "European Union"],
};

const MARQUEE_A = ["Company Formation", "D2 Visa", "NIF & Banking", "Relocation", "Accounting", "Expansion"];
const MARQUEE_B = ["Build", "Move", "Grow", "Belong", "Build Your Future in Portugal"];

export default function Home() {
  return (
    <div className="bg-maroon-deep">
      <Seo
        title="Effizent Europe — Build Your Future in Portugal"
        description="Effizent Europe is the Portugal Business & Relocation Partner for Indians. From company formation and the D2 visa to banking, relocation and growth — we help you build your future in Portugal."
        jsonLd={jsonLd}
        canonical={typeof window !== "undefined" ? window.location.origin : undefined}
      />
      <Navbar />
      <AirplaneProgress />
      <SceneJourney />
      <SceneFlight />
      <SceneArrival />
      <Marquee items={MARQUEE_A} duration={34} />
      <Roadmap />
      <Marquee items={MARQUEE_B} duration={30} reverse bg="bg-navy-deep" text="text-cream" />
      <TrustSection />
      <FinalVision />
      <CTABand />
      <Footer />
    </div>
  );
}
